/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { constants } from '../../modules/utils/constants';
const AccountOverviewNotification = dynamic(() =>
  import('./AccountOverviewNotification').then(mod => mod.AccountOverviewNotification)
);
const AccountOverviewNotificationV2 = dynamic(() =>
  import('./AccountOverviewNotificationV2').then(mod => mod.AccountOverviewNotificationV2)
);

export const AccountOverviewNotificationConfig = {
  emptyLabel: 'accountoverviewnotification',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/accountoverviewnotification`,
};
export const AccountOverviewNotificationEditable = (props: any) => {
  return (
    <EditableComponent config={AccountOverviewNotificationConfig} {...props}>
      {props?.model?.variation === constants.VARIATION_2 ? (
        <AccountOverviewNotificationV2 {...props} />
      ) : (
        <AccountOverviewNotification {...props} />
      )}
    </EditableComponent>
  );
};
